<template>
  <div class="wizard-body w-[75%] flex-shrink-0 flex-grow-0 max-w-[75%]">
    <page-header
      :header-title="$t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.DESC')"
    />
    <form class="mx-0 flex flex-wrap" @submit.prevent="createChannel()">
      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label :class="{ error: $v.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.CHANNEL_NAME.LABEL') }}
          <input
            v-model.trim="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="$v.channelName.$touch"
          />
          <span v-if="$v.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>

      <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
        <label>
          {{ $t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.SELLER_MOBILE.LABEL') }}
          <input
            v-model="sellerMobile"
            type="tel"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="tel"
            :placeholder="
              $t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.SELLER_MOBILE.PLACEHOLDER')
            "
            @input="onSellerMobileInput"
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.SELLER_MOBILE.SUBTITLE') }}
        </p>
      </div>

      <div class="w-full">
        <woot-submit-button
          :loading="uiFlags.isCreating"
          :button-text="$t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import alertMixin from 'shared/mixins/alertMixin';
import { required } from 'vuelidate/lib/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader';

export default {
  components: {
    PageHeader,
  },
  mixins: [alertMixin],
  data() {
    return {
      channelName: '',
      sellerMobile: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations: {
    channelName: { required },
  },
  methods: {
    onSellerMobileInput(event) {
      this.sellerMobile = (event.target.value || '').replace(/\D/g, '');
    },
    async createChannel() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      try {
        const channelPayload = {
          type: 'indiamart',
        };
        const sellerMobile = (this.sellerMobile || '').replace(/\D/g, '');
        if (sellerMobile) {
          channelPayload.seller_mobile = sellerMobile;
        }

        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName,
          channel: channelPayload,
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: inbox.id,
          },
        });
      } catch (error) {
        this.showAlert(
          this.$t('INBOX_MGMT.ADD.INDIAMART_CHANNEL.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>
